import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';

type Props = { sx?: SxProps };

export const HorizontalDivider: React.FunctionComponent<Props> = function ({ sx }) {
    const theme = useTheme();
    const dividerStyle = {
        minWidth: '15px',
        width: '100%',
        minHeight: '1px',
        backgroundColor: theme.palette.divider,
        ...sx,
    };
    return (
        <Box
            sx={dividerStyle}
            data-testid="HorizontalDivider-test-id"
        />
    );
};
